<template>
  <q-td :props="props" :key="colKey">
    <ams-base-cell-standort :props="props" />
  </q-td>
</template>

<script lang="ts">
import BaseCellStandort from "../../../components/BaseCells/BaseCellStandort.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    "ams-base-cell-standort": BaseCellStandort,
  },
  props: {
    props: {
      type: Object,
      required: true,
    },
    colKey: {
      type: String,
      required: true,
    },
  },
});
</script>
